import absoluteUrl from 'next-absolute-url';
import { fetcher } from 'Utils/fetcher';
import { GetServerSideProps } from 'next';
import { ISkills } from '@Types';
import styled from 'styled-components';
import Typed from 'react-typed';

import { Container } from 'Atoms/Container';
import { SeoHead } from 'Atoms/SeoHead';

interface IProps {
	skills: ISkills;
}

function Home({ skills }: IProps) {
	const { technologies, frameworks } = skills;

	const talkAbout = [...technologies, ...frameworks];

	return (
		<>
			<SeoHead
				title="Junaid Umer - Senior iOS Developer"
				description="I develop iOS Applications in Swift language. I am a strong engineering professional with a Master's focus in Information Technology from the University of Sargodha. I have 4+ years of experience in iOS development working with many frameworks like Uikit, UlFoundation. Mobile Core Services, WebKit. AV Foundation, Core Data, Firebase, REST APIs, User Authentication using Facebook, Twitter. Gmail, Google-Plus, and integrated payment methods using PayPal and Stripe. In my professional field, I have worked on about 10 iOS apps."
			/>

			<Container>
				<Headline>
					Hey, I&apos;m Junaid Umer
					<br />
					Sr. iOS Developer <span>👋</span>
				</Headline>
				<p>
					{' '}
					I develop iOS Applications in Swift language. I am a strong
					engineering professional with a Master's focus in Information
					Technology from the University of Sargodha. I have 4+ years of
					experience in iOS development working with many frameworks like Uikit,
					UlFoundation. Mobile Core Services, WebKit. AV Foundation, Core Data,
					Firebase, REST APIs, User Authentication using Facebook, Twitter.
					Gmail, Google-Plus, and integrated payment methods using PayPal and
					Stripe. In my professional field, I have worked on about 10 iOS apps.{' '}
					<br /> <br /> You can contact me at{' '}
					<a href="mailto:junaidumer28@gmail.com">junaidumer28@gmail.com</a>.
					You can talk to me about{' '}
					<Typed
						loop
						typeSpeed={80}
						backSpeed={20}
						strings={talkAbout}
						smartBackspace
						backDelay={1000}
						loopCount={0}
						showCursor
						cursorChar="|"
					/>
					.
				</p>
			</Container>
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
	const { origin } = absoluteUrl(req);
	const skills = await fetcher(`${origin}/api/skills`);

	return {
		props: {
			skills,
		},
	};
};

const Headline = styled.h2`
	font-size: 2rem;

	span {
		display: none;
	}

	@media screen and (min-width: 768px) {
		font-size: 3rem;

		span {
			display: inline-block;
		}

		@keyframes wave {
			0% {
				transform: rotate(0);
			}
			50% {
				transform: rotate(-10deg);
			}
			100% {
				transform: rotate(10deg);
			}
		}

		&:hover span {
			animation: wave 0.5s ease infinite;
		}
	}
`;

export default Home;
